import React, { useState, useEffect } from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TablePagination,
  FormControl,
  InputLabel,
  Select,
  Chip,
  MenuItem,
} from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import AddIcon from "@mui/icons-material/Add";
import "./SheetList.css";

import Navbar from "../../Navbar";
import Sidebar from "../../Sidebar";
import axios from "axios";

function SheetList() {
  const { API_CONFIG } = require("../../../configuration");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [existingSheets, setExistingSheets] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedSheet, setSelectedSheet] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openCreate, setOpenCreate] = useState(false);
  const [newSheetName, setNewSheetName] = useState("");
  const [status, setStatus] = useState("Active");

  useEffect(() => {
    const token = localStorage.getItem("token");

    axios
      .get(`${API_CONFIG.APIURL}/call/track/sheetsList`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setExistingSheets(res.data);
      })
      .catch((err) => {
        // console.log(err.response?.data || err.message);
      });
  }, []);

  const handleEdit = (sheet) => {
    setSelectedSheet(sheet);

    setEditName(sheet.sheet_name);

    setOpenEdit(true);
  };

  const handleCreateSheet = async () => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));
    const emp_id = user?.emp_id;

    if (!newSheetName.trim()) {
      setSnackbarMessage("Please enter sheet name");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    try {
      const res = await axios.post(
        `${API_CONFIG.APIURL}/call/track/sheets/create`,
        {
          sheet_name: newSheetName,
          created_by: emp_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setExistingSheets((prev) => [res.data, ...prev]);

      setSnackbarMessage("Sheet created successfully");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      setOpenCreate(false);
      setNewSheetName("");
    } catch (err) {
      // console.log("Create sheet error:", err.response?.data || err.message);

      setSnackbarMessage(
        err.response?.data?.message || "Failed to create sheet",
      );
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleSave = async () => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));
    const emp_id = user?.emp_id;

    try {
      await axios.put(
        `${API_CONFIG.APIURL}/call/track/sheets/${selectedSheet.id}`,
        {
          name: editName,
          status: status,
          empid: emp_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setExistingSheets((prev) =>
        prev.map((item) =>
          item.id === selectedSheet.id
            ? {
                ...item,
                sheet_name: editName,
                status: status,
              }
            : item,
        ),
      );

      setSnackbarMessage("Sheet updated successfully");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      setOpenEdit(false);
      setSelectedSheet(null);
    } catch (err) {
      // console.log("Update error:", err.response?.data || err.message);

      setSnackbarMessage("Failed to update sheet");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  return (
    <>
      <Navbar />
      <Sidebar />

      <Box
        sx={{
          p: { xs: 1.5, sm: 2, md: 3 },
          ml: { xs: 0, md: "250px" },
          width: {
            xs: "100%",
            md: "calc(100% - 250px)",
          },
          boxSizing: "border-box",
          overflowX: "hidden",
          backgroundColor: "#F9FAFB",
          minHeight: "100vh",
        }}
      >
        <div className="sheet-header">
          <Typography variant="h4" className="sheet-title">
            List of Sheet's
          </Typography>

          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setOpenCreate(true)}
          >
            New Sheet
          </Button>
        </div>

        <Paper className="table-box">
          <Table>
            <TableHead>
              <TableRow className="table-header">
                <TableCell>S.NO</TableCell>
                <TableCell>Sheet Name</TableCell>
                <TableCell>No.of Records</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Created By</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {existingSheets
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((x, index) => (
                  <TableRow key={x.id}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{x.sheet_name}</TableCell>
                    <TableCell>{x.total_records}</TableCell>
                    <TableCell>
                      <Chip
                        label={x.status}
                        color={x.status === "Active" ? "success" : "error"}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      {new Date(x.created_at).toLocaleDateString("en-GB")}
                    </TableCell>
                    <TableCell>{x.created_by}</TableCell>
                    <TableCell>
                      <Button
                        className="action-btn"
                        variant="contained"
                        onClick={() => handleEdit(x)}
                      >
                        Edit
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <Paper className="table-box">
            {/* <Table>
              <TableHead>...</TableHead>

              <TableBody>...</TableBody>
            </Table> */}

            <TablePagination
              component="div"
              count={existingSheets.length}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={(event, newPage) => {
                setPage(newPage);
              }}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));

                setPage(0);
              }}
              rowsPerPageOptions={[10, 30, 50, 100]}
            />
          </Paper>
        </Paper>
        <Dialog
          open={openEdit}
          onClose={() => setOpenEdit(false)}
          PaperProps={{
            sx: {
              width: "500px",
              maxWidth: "90%",
              borderRadius: "12px",
            },
          }}
        >
          <DialogTitle>Edit Sheet Name</DialogTitle>

          <DialogContent>
            <TextField
              fullWidth
              value={editName}
              onChange={(e) => setEditName(e.target.value)}
              sx={{ mt: 2 }}
              label="Sheet Name"
            />
          </DialogContent>

          <DialogContent>
            <FormControl fullWidth sx={{ mt: 1 }}>
              <InputLabel>Status</InputLabel>

              <Select
                value={status}
                label="Status"
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenEdit(false)}>Cancel</Button>

            <Button variant="contained" color="success" onClick={handleSave}>
              Save
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openCreate}
          onClose={() => setOpenCreate(false)}
          PaperProps={{
            sx: {
              width: "500px",
              maxWidth: "90%",
              borderRadius: "12px",
            },
          }}
        >
          <DialogTitle>Create New Sheet</DialogTitle>

          <DialogContent>
            <TextField
              fullWidth
              label="Sheet Name"
              value={newSheetName}
              onChange={(e) => setNewSheetName(e.target.value)}
              sx={{ mt: 2 }}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenCreate(false)}>Cancel</Button>

            <Button
              variant="contained"
              color="primary"
              onClick={handleCreateSheet}
              disabled={!newSheetName.trim()}
            >
              Create
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={() => setSnackbarOpen(false)}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackbarSeverity}
            variant="filled"
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );
}

export default SheetList;
